import { magnificPopupIframe, magnificPopupInline, magnificPopupSingleImage, magnificPopupGalleryImage } from './popups'
import { basicSlider } from './sliders';
import { linksCustomization, scrollTo, responsiveTables, smoothScrolling } from './misc';
import setScrollBarWidth from 'set-scrollbar-width';  // Use with the Tailwind Container Break Out extension.
import Isotope from "isotope-layout";
import Lenis from "lenis";
import { lenis } from "./misc.js";

import gsap from 'gsap';


import ScrollTrigger from 'gsap/ScrollTrigger';
import MorphSVGPlugin from 'gsap/MorphSVGPlugin';
import ScrollToPlugin from "gsap/ScrollToPlugin";
import CustomEase from 'gsap/CustomEase';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(MorphSVGPlugin);
gsap.registerPlugin(CustomEase);
gsap.registerPlugin(ScrollToPlugin)

 



// gsap.to(".step1", { duration: 1, yoyo:true, repeat:-1, repeatDelay:1,  ease: "power2.out", morphSVG:{
// 	shape: ".step2",
// 	shapeIndex: 3,
// 	map: "complexity",
// 	precision: 5
//    } });



import menu from "./menu";

/* Flexible Content */
import { pltcap } from '../../templates/blocks/platform-capabilities/platform-capabilities';
import { productsblock } from '../../templates/blocks/products/products';
import { whoweserve } from '../../templates/blocks/who-we-serve/who-we-serve';
import { clientlogos } from '../../templates/blocks/clients/clients';
import { testimonialblock } from '../../templates/blocks/testimonials/testimonials';
import { latestnews } from '../../templates/blocks/latest-news/latest-news';
import { imagecarousel } from '../../templates/blocks/image-carousel/image-carousel';
import { whyfinbourne } from '../../templates/blocks/why-finbourne/why-finbourne';
import { wherenext } from '../../templates/blocks/where-next/where-next';
import { statsblock } from '../../templates/blocks/stats-grid/stats-grid';
import { hscroll } from '../../templates/blocks/horizontal-carousel/horizontal-carousel';




/* Templates */
import { homepage } from './home';
import { newspage } from './news';
import LoadedObject from './homewebgl.js';
import LoadedObjectContact from './contactwebgl.js';


function consoleMessage(){
	console.log('%cCreated by %cTWK%cwww.thewebkitchen.co.uk', 'background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;', 'background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;', 'background: #FFFFFF; padding: 5px 10px;');
}

function usingJS(){
	document.querySelector('html').classList.remove('no-js')
	document.querySelector('html').classList.add('js')
}

function intro_head() {
	if (document.body.classList.contains('home')) {
		let timeline_introhead = gsap.timeline({delay:.2});
		const menu_bar = document.querySelector('[data-target="menu_bar"]');
		const menu_bar_content = document.querySelector('[data-target="menu_bar_list"]');
		gsap.set(menu_bar, {autoAlpha:1})
		gsap.set('#menu_corner_tl', {autoAlpha:1})
		timeline_introhead.from(menu_bar, { y:"-120px", duration:1,}, "start")
		.from('#menu_corner_tl', {y:"-120px", duration:1.01 }, "start")
		.from(menu_bar_content, {autoAlpha:0, duration:.5})
	}
	
    
}


/* *********************** */
/* Start all the functions */
/* *********************** */
window.onload = function() {
	// Init
	consoleMessage()
	usingJS()
	setScrollBarWidth()
	linksCustomization()
	scrollTo()
	responsiveTables()
	smoothScrolling()
	
	menu();
	intro_head();

	// Popups
	magnificPopupIframe()
	magnificPopupInline()
	magnificPopupSingleImage()
	magnificPopupGalleryImage()

	// Sliders
	basicSlider()

	//Templates
	homepage();
	newspage();
	LoadedObject();
	LoadedObjectContact();

	// Flexible Content
	pltcap();
	productsblock();
	whoweserve();
	clientlogos();
	testimonialblock();
	latestnews();
	imagecarousel();
	whyfinbourne();
	//wherenext();
	statsblock();
	hscroll();


	const box_up = document.querySelectorAll('[data-anim="box_up"]');

	box_up.forEach(function(element) {
		const height = element.offsetHeight;
		const content_el = element.firstElementChild; 
		const boxDownElement = element.nextElementSibling;
		const content_boxDownElement = boxDownElement?.children; 

		if (window.matchMedia("(min-width: 1024px)").matches) {
			element.style.marginTop = `-${height}px`;
		}

		const tlbox = gsap.timeline({
			scrollTrigger: {
				trigger: element,
				start: "top 80%",
			}
		});
		gsap.set('#neckproduct', {autoAlpha:1})
		tlbox
			.to(element, { scale: 1, duration: 1, ease: "power3.out" }) 
			.to(content_el, { autoAlpha: 1, duration: 0.5 }, "-=0.5") 
			.to(boxDownElement, { scale: 1, duration: 1, ease: "power3.in" }, "-=0.5") 
			.from('#neckproduct', {scaleX:0, scaleY:.8,  duration:1,  ease: "power3.out" }, "-=.4")
			
			.to(content_boxDownElement, { autoAlpha: 1, duration: 0.5 }, "-=0.2");
	});



	const box_up_feature = document.querySelectorAll('[data-anim="box_up_feature"]');

	box_up_feature.forEach(function(element) {
		const height = element.offsetHeight;
		const content_el = element.firstElementChild; 
		const boxDownElement = element.nextElementSibling;
		const boxDownElement_h = boxDownElement.offsetHeight;
		const boxcontentDownElement = element.parentElement.nextElementSibling;
		const content_boxDownElement = boxDownElement?.children;
		const content_boxDownElement_2 = boxDownElement.querySelector('img')
		const neck = element.querySelector('[data-target="neck"]')
		
		if (window.matchMedia("(min-width: 1024px)").matches) {
			boxcontentDownElement.style.marginTop = `-${boxDownElement_h}px`;

			boxDownElement.style.marginTop = `+${height}px`;

		}

		const tlbox = gsap.timeline({
			scrollTrigger: {
				trigger: element,
				start: "top 80%",
			}
		});

		
		tlbox
			.from(element, { scale: 0, duration: 1, ease: "power3.out" }) 
			.to(content_el, { autoAlpha: 1, duration: 0.5 }, "-=0.5") 
			.from(boxDownElement, { scale: 0, duration: 1, ease: "power3.in" }, "-=0.5") 
			.from(content_boxDownElement_2, {autoAlpha:0, duration:.5, ease: "none"}, "-=0.3")
			.from(neck, {scaleX:0, scaleY:.8,  duration:1,  ease: "power3.out" }, "-=.4")
			.from(boxcontentDownElement, {autoAlpha:0, duration:0.5,ease: "none"},  "-=0.9")
	});


	const tlbox2 = gsap.timeline({
		scrollTrigger: {
			trigger: '[data-anim="box_up_2"]',
			start: "top 80%",
		}
	});

	tlbox2
	.to('[data-anim="box_up_2"], [data-anim="box_down_2"]', { scale:1, autoAlpha: 1, duration: 1, ease: "power2.out" }) 
	.to('[data-anim="box_up_2"], [data-anim="box_down_2"]', { y:0, x:0, duration: 1, ease: "power3.out" }, "-=1") 


	const banner_image = document.querySelector('[data-target="banner_image"]');
	const sub_2 = document.querySelector('[data-target="sub_2"]');

	if (banner_image && sub_2) {
		const sub2Height = sub_2.offsetHeight - 25;
		const sub2Height_b = sub_2.offsetHeight / 2 - 15;
		//banner_image.style.paddingBottom = `${sub2Height}px`;
		//sub_2.style.bottom = `-${sub2Height_b}px`;

	}

	
	
	
	

	
}



jQuery(document).ready(function ($) {
	ajax: {
		/**
		 * Detects the "Search & Filter" plugin ajax call and re-starts "Magnific popup".
		 */
		$(document).on("sf:ajaxfinish", ".searchandfilter", function(){
			magnificPopupIframe()
			magnificPopupInline()
			magnificPopupSingleImage()
			magnificPopupGalleryImage()
		});
	}
	
	isotope: {
		
		
		if($('#grid-team').length) {
			function isotopeteam() {
				var grid = document.getElementById('grid-team');
				var iso = new Isotope( grid, {
						itemSelector: ".element-item",
						layoutMode: 'fitRows',
						
				});
				
				setTimeout(function(){ 
					$( ".is-checked" ).trigger( "click" );

				}, 500);

				
				$( '.button-group button' ).on('click', function(e){
					$( '.button-group button' ).removeClass('is-checked');
					$(this).addClass('is-checked');
					var data = $(this).attr('data-filter');
					iso.arrange({
					filter: data // All grid items
					});
				});
			}
			isotopeteam();	
		}
		
	}
	image_video: {
		document.querySelectorAll('.video_img').forEach(function(block) {
			// Get the Vimeo ID from the data-content attribute
			let vimeoId = block.getAttribute('data-content');
		
			// Fetch the Vimeo oEmbed JSON to get the thumbnail
			fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${vimeoId}`)
				.then(response => response.json())
				.then(data => {
					// Get the thumbnail URL from the response
					let thumbnailUrl = data.thumbnail_url;
		
					// Create an img element for the thumbnail
					let newImg = document.createElement('img');
					newImg.src = thumbnailUrl;
					newImg.alt = 'Vimeo Thumbnail';
					newImg.classList.add('w-full', 'h-auto'); // Add any classes you need
		
					// Insert the image into the block
					block.appendChild(newImg);
				})
				.catch(error => {
					console.error('Error fetching Vimeo data:', error);
				});
		});
		
		
	} 
	trustedby: {
		const trustedHomeProduct = document.querySelector('[data-target="trusted_home_product"]');
		if (trustedHomeProduct) {
			gsap.to(trustedHomeProduct, {autoAlpha:1, duration:.5, delay:.5})
		}
		const RandomImages = Array.from(document.querySelectorAll('[data-target="random_img_item"]'));
		if (RandomImages.length > 0) {
			function shuffleArray(arr) {
				return arr.sort(() => Math.random() - 0.5);
			}
		
			let visibleItems = shuffleArray(RandomImages).slice(0, 3);
			let hiddenItems = RandomImages.filter(item => !visibleItems.includes(item));
		 
		
			visibleItems.forEach(item => {
				item.classList.remove('invisible');
				gsap.set(item, { autoAlpha: 1 });  
			});
			hiddenItems.forEach(item => {
				item.classList.add('invisible');
				item.style.display = 'none';
				gsap.set(item, { autoAlpha: 0 });  
			});
		
		
			function replaceImage() {
				if (visibleItems.length > 0 && hiddenItems.length > 0) {
					const randomVisibleIndex = Math.floor(Math.random() * visibleItems.length);
					const visibleItem = visibleItems[randomVisibleIndex];
		
					const randomHiddenIndex = Math.floor(Math.random() * hiddenItems.length);
					const hiddenItem = hiddenItems[randomHiddenIndex];
					
					const parent = visibleItem.parentElement;
		
					hiddenItem.classList.remove('invisible');
					gsap.set(hiddenItem, { autoAlpha: 0 });
					
					gsap.to(visibleItem, {
						autoAlpha: 0,
						duration: .5,
						onComplete: function() {
							hiddenItem.style.display = 'flex'; 
							parent.replaceChild(hiddenItem, visibleItem);
		
							gsap.to(hiddenItem, {
								autoAlpha: 1,
								duration: .5,
								onComplete: function() {
									hiddenItems.push(visibleItem);  
									visibleItems[randomVisibleIndex] = hiddenItem;  
									hiddenItems.splice(randomHiddenIndex, 1);  
		
									visibleItem.classList.add('invisible');
									gsap.set(visibleItem, { autoAlpha: 0 });
								}
							});
						}
					});
				}
			}
		
			setInterval(replaceImage, 3000);
		}
	}
	video_popup : {

		if ($('[data-function="video_modal"]').length) {
			gsap.set('#modal_video', {autoAlpha:0})
			$( '[data-function="video_modal"]' ).on('click', function(e){
				e.preventDefault();
				$('#modal_video').removeClass('!hidden');
				const content =  $(this).data('content');
				const updateclass = document.getElementById('updateclass');
				updateclass.className = `wistia_embed wistia_async_${content} seo=true videoFoam=true`;


				// Dynamically create and append the Wistia script
				const wistiaScript = document.createElement('script');
				wistiaScript.src = `https://fast.wistia.com/embed/medias/${content}.jsonp`;
				wistiaScript.async = true;
				document.head.appendChild(wistiaScript);
				
				
				gsap.to('#modal_video', {autoAlpha:1, duration:.5, delay:.2});
				gsap.from('#modal_video_box', {scale:.8, autoAlpha:0, duration:.5, delay:.2});
				lenis.stop();
			});

			$( '#close_modal_video' ).on('click', function(e){
				e.preventDefault();
				gsap.to('#modal_video', {autoAlpha:0, duration:.5, delay:.2, onComplete: function() {
					$('#modal_video').addClass('!hidden');
				}});
				lenis.start();
				// Remove the Wistia script element if it exists
				const existingWistiaScript = document.querySelector('script[src^="https://fast.wistia.com/embed/medias/"]');
				if (existingWistiaScript) {
					existingWistiaScript.remove();
				}

			});
			
		}

	}

	converions: {
		if ($('[data-target="conv_form_content"]').length) {

			const hconv_form_content = document.querySelector('[data-target="conv_form_content"]').offsetHeight + 80;
			document.querySelector('#conv_form_content_corner').style.top = `${hconv_form_content}px`;

			
		}

	}
	

	team: {
	

		if ($('[data-target="team_page"]').length) {
		
	
			$('[data-target="team_box"]').on( 'click', function(e) {
				e.preventDefault();
				var postid = $(this).attr('data-postid');
				$.ajax({
					type: "GET",
						url: my_ajax_object.ajax_url,
						dataType : 'html',
						data: {
						action: 'my_load_ajax_content_team',
						idpost: postid,
						}
				}).done(function (data) {
					$('#boxcontent_team').html(data);
					gsap.to('#boxcontent_team', {autoAlpha:1, duration:.3});
					gsap.from('#boxcontent_team > div', { autoAlpha:0, duration:.6, delay:.4})
					$(document).on("click", '[data-element="close_popup_team"]', function(event) { 
						let tl = gsap.timeline();
						tl.to('#boxcontent_team > div', { autoAlpha:0, duration:.5})
						.to('#boxcontent_team', {autoAlpha:0, duration:.3});
						
					});
				
				});
			});

		}

	}

	
	scrollto: {
		
			
		const scrollLinks = document.querySelectorAll('[data-target="scrollto"]');

		scrollLinks.forEach(link => {
			link.addEventListener('click', function(e) {
				e.preventDefault(); 

				const targetId = link.getAttribute('href');
				const targetElement = document.querySelector(targetId);
				const targetPosition = targetElement.offsetTop - 130;
				if (targetElement) {
					gsap.to(window, {duration: 1,  scrollTo: {y: targetPosition, autoKill: false   }});
				}
			});
		});
	
		
	}
	boxsvg: {
		

	}
});

